import { useSelector } from 'react-redux';

import { hasPersistedMemberSession, type FunctionalRootState } from '@share/utils';
import type { ILoginState } from '@share/store/slices';

/** True when a persisted member session exists (private success CTAs apply). */
export function useIsCertificateMemberLoggedIn(): boolean {
  const { account } = useSelector(
    (state: FunctionalRootState) => state.loginStore,
  ) as ILoginState;

  return hasPersistedMemberSession(account);
}
